import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/app/components/ui/dialog'
import { Button } from '@/app/components/ui/button'
import { Input } from '@/app/components/ui/input'

export interface CashWithdrawalModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  currentCashInRegister: number
  withdrawalAmount: string
  setWithdrawalAmount: (amount: string) => void
  withdrawalConcept: string
  setWithdrawalConcept: (concept: string) => void
  isSubmitting?: boolean
  handleCashWithdrawal: () => void
  setShowCashWithdrawal: (show: boolean) => void
}

export function CashWithdrawalModal({
  open,
  onOpenChange,
  currentCashInRegister,
  withdrawalAmount,
  setWithdrawalAmount,
  withdrawalConcept,
  setWithdrawalConcept,
  isSubmitting,
  handleCashWithdrawal,
  setShowCashWithdrawal,
}: CashWithdrawalModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Retiro de Efectivo</DialogTitle>
          <DialogDescription className="sr-only">
            Retirar efectivo de la caja
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-lg bg-slate-50 p-4">
            <p className="text-sm text-slate-600">Efectivo en caja:</p>
            <p className="text-2xl font-semibold text-slate-900">
              ${currentCashInRegister.toFixed(2)} MXN
            </p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700">
              Monto a retirar: <span className="text-red-600">*</span>
            </label>
            <Input
              type="number"
              value={withdrawalAmount}
              onChange={(e) => setWithdrawalAmount(e.target.value)}
              placeholder="0.00"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700">
              Concepto: <span className="text-red-600">*</span>
            </label>
            <Input
              value={withdrawalConcept}
              onChange={(e) => setWithdrawalConcept(e.target.value)}
              placeholder="Ej: Pago a proveedor, gastos varios..."
            />
          </div>



          <div className="flex gap-2">
            <Button
              onClick={handleCashWithdrawal}
              className="flex-1"
              disabled={
                !withdrawalAmount ||
                parseFloat(withdrawalAmount) <= 0 ||
                parseFloat(withdrawalAmount) > currentCashInRegister ||
                !withdrawalConcept.trim() ||
                isSubmitting
              }
            >
              {isSubmitting ? 'Procesando...' : 'Aceptar'}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setShowCashWithdrawal(false)
                setWithdrawalAmount('')
                setWithdrawalConcept('')
              }}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
